<template>

</template>

<script>
import api from '../utils/api';
import { setIdToken, setAccessToken, saveUser } from '../utils/auth';

export default {
  name: '',
  mounted() {
    this.$nextTick(() => {
      setAccessToken();
      setIdToken();
      api.buildRequest('user', 'GET')
        .then((response) => {
          if (response.status === 200) {
            saveUser(response.data.payload.data);
            window.location.href = '/summary';
          }
        });
    });
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Callback.vue